<template>
    <div>
        <div id="checkout-page" class="basket-checkout-page-container">           
            <pc-gtm-event-logger 
            :key="getGtmEventBasketItems.length" 
            :eventName="GTMEventName" 
            :basketProducts="(getGtmEventBasketItems || [])"
            v-if="basketItems !== undefined && getGtmEventBasketItems.length > 0" />
            <section id="mybasket-heading" class="text-center bg-white main-heading-page">
                <h2>
                    {{ $resourceString["basket.BasketPageTitle"] }}
                </h2>
            </section>

            <div class="container-fluid basket-checkout-page-details">
                <!-- basket item -->
                <div class="row align-items-start">
                    <!-- left-->
                    <div :class="(!isSideBar) ? 'col-12' : 'col-12 col-lg-8 col-xl-9'">
                        <!-- Basket items -->
                        <div id="basket-container" class="basket-list-warpper">
                            <div class="basket-item-list-row"
                                v-if="basketItems && basketItems.SiteItems && basketItems.SiteItems.length > 0">
                                <pc-basket-accordion 
                                    :title="$resourceString['myBasket.Label.IndividualSamples']"
                                    sectionId="#IndividualSamples" 
                                    :itemCount="basketCount.siteItems" 
                                    :isDefaultExpand="isAccordionExpand === siteItems"
                                />
                                <div class="basket-item-list show" :class="{'show':(isAccordionExpand === siteItems)}" id="IndividualSamples">
                                    <basket-item :listItems="basketItems.SiteItems"
                                        :clearAllTitle="$resourceString['basket.ClearWebsiteItems']" :isClearAll="true"
                                        :listName="siteItems" />
                                </div>
                            </div>
                            <div class="basket-item-list-row"
                                v-if="basketItems && basketItems.ProjectItems && basketItems.ProjectItems.length > 0">
                                <pc-basket-accordion :title="$resourceString['myBasket.Label.ProjectSamples']"
                                    sectionId="#ProjectSamples" :itemCount="basketCount.projectItems" 
                                    :isDefaultExpand="isAccordionExpand === projectItems"
                                    />
                                <div class="basket-item-list collapse" :class="{'show':(isAccordionExpand === projectItems)}" id="ProjectSamples">
                                    <basket-item :listItems="basketItems.ProjectItems"
                                        :clearAllTitle="$resourceString['basket.ClearProjectsItems']" :isClearAll="true"
                                        :listName="projectItems" />
                                </div>
                            </div>
                            <div class="basket-item-list-row basket-list-tray-items"
                                v-if="basketItems && basketItems.TrayItems && basketItems.TrayItems.length > 0">
                                <pc-basket-accordion :title="$resourceString['myBasket.Label.DesignTraySample']"
                                    sectionId="#DesignTraySample" :itemCount="basketCount.trayItems" :isDefaultExpand="isAccordionExpand === trayItems"/>
                                <div class="basket-item-list collapse" :class="{'show':(isAccordionExpand === trayItems)}" id="DesignTraySample">
                                    <basket-item :listItems="basketItems.TrayItems" :clearAllTitle="$resourceString['basket.ClearTrayItems']" :isClearAll="true" :listName="trayItems" />
                                </div>
                            </div>

                            <!-- empty basket -->
                            <pc-empty-basket v-if="!basketItems.HasSiteItems && !basketItems.HasTrayItems && !basketItems.HasProjectItems" />

                            <!-- Save for later Item -->
                             <div class="basket-list-save-for-later-container" v-if="(saveForLater.SiteItems && saveForLater.SiteItems.length > 0) || (saveForLater.ProjectItems && saveForLater.ProjectItems.length > 0)">
                                <h4 class="primary-heading font-weight-bold">
                                  {{ $resourceString['basket.SaveForLater.Title'] }}
                                </h4>
                                <div class="basket-item-list-row basket-list-save-for-later" v-if="saveForLater.SiteItems && saveForLater.SiteItems.length > 0">
                                    <pc-basket-accordion :title="$resourceString['myBasket.Label.IndividualSamples']" sectionId="#SaveForLaterItems_SiteItems" :itemCount="saveForLaterCount.siteItems" :isDefaultExpand="isAccordionExpand === `saveForLater-${this.siteItems}`" />
                                    <div class="basket-item-list collapse" id="SaveForLaterItems_SiteItems" :class="{'show':(isAccordionExpand === `saveForLater-${this.siteItems}`)}">
                                        <pcBasketSaveForLater listName="SiteItems" :listItems="saveForLater.SiteItems" />
                                    </div>
                                </div> 
                                <div class="basket-item-list-row basket-list-save-for-later" v-if="saveForLater.ProjectItems && saveForLater.ProjectItems.length > 0">
                                    <pc-basket-accordion :title="$resourceString['myBasket.Label.ProjectSamples']" sectionId="#SaveForLaterItems_ProjectItems" :itemCount="saveForLaterCount.projectItems" :isDefaultExpand="isAccordionExpand === `saveForLater-${projectItems}`" />
                                    <div class="basket-item-list collapse" id="SaveForLaterItems_ProjectItems" :class="{'show':(isAccordionExpand === `saveForLater-${projectItems}`)}">
                                        <pcBasketSaveForLater listName="ProjectItems" :listItems="saveForLater.ProjectItems" />
                                    </div>
                                </div> 
                             </div>
                                              

                        </div>

                    </div>

                    <!-- Right --> 
                                   
                    <div class="col-12 col-lg-4 col-xl-3 sidebar-position-sticky sidebar-mobile-device" v-if="isSideBar">
                        <div class="checkout-basket-sidebar-warpper">
                            <div class="checkout-basket-sidebar-container">
                                <pc-basket-sidebar
                                    :individualSamples="(basketItems && basketItems.SiteItems && basketItems.SiteItems.length > 0)"
                                    :individualSamplesCount="basketCount.siteItems"
                                    :projectSamples="(basketItems && basketItems.ProjectItems && basketItems.ProjectItems.length > 0)"
                                    :projectSamplesCount="basketCount.projectItems"
                                    :designTraySample="(basketItems && basketItems.TrayItems && basketItems.TrayItems.length > 0)"
                                    :designTraySampleCount="basketCount.trayItems"
                                    :nextLabel="$resourceString['myBasket.Button.Continue']"
                                    :nextAction="() => continueToCheckOut(checkoutTypeMixed)"
                                    :isNextDisabled="isErrorForSideBar()"
                                    :isError="isErrorForSideBar()"
                                    :errorMsg="errorMsgForSideBar()"
                                    v-if="basketItems.HasSiteItems || basketItems.HasTrayItems || basketItems.HasProjectItems"
                                />                                
                                <pc-ideabook />
                            </div>
                        </div>
                    </div>                     
                    
                </div>

            </div>
        </div> 

        <pc-page-loader :loader="loader" />
        <pc-ideabook-recommendation-modal :continueToCheckOut="continueToCheckOutIdeabook" v-if="(basketItems.HasSiteItems) && basketItems.AskToAddIdeabook" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BasketItem from "./pc-basket-list.vue";
import PCGTMEventLogger from "../pc-gtm-event-logger.vue";
import PcBasketAccordion from "./pc-basket-accordion.vue";
import pcPageLoader from "./pc-page-loader.vue";
import pcBasketSidebar from "./pc-basket-sidebar.vue";
import pcIdeabook from "./pc-ideabook.vue";
import pcContinueCheckoutModal from "./pc-continue-checkout-modal.vue";
import pcEmptyBasket from "./pc-empty-basket.vue";
import pcBasketSaveForLater from "./pc-basket-save-for-later.vue";
import { VIEW_CART_EVENT_NAME, BEGIN_CHECKOUT_EVENT_NAME } from "../../../constants/gtm-constants";
import { BASKET_SITEITEMS, BASKET_PROJECTITEMS, BASKET_TRAYITEMS, CHECKOUT_TYPE_MIXED } from "../../../constants/checkout-constant";
import pcIdeabookRecommendationModal from "./pc-ideabook-recommendation-modal.vue";

export default {
    props: [
        "maxallowedcartitems",
        "maxallowedsamplesincartitem",
        "maxfullsizeitems"
    ],
    components: {
        BasketItem,
        "pc-gtm-event-logger": PCGTMEventLogger,
        PcBasketAccordion,
        pcPageLoader,
        pcBasketSidebar,
        pcIdeabook,
        pcContinueCheckoutModal,
        pcEmptyBasket,
        pcBasketSaveForLater,
        pcIdeabookRecommendationModal
    },
    data() {
        return {
            GTMEventName: VIEW_CART_EVENT_NAME,
            GTMEventNameBegin: BEGIN_CHECKOUT_EVENT_NAME,
            siteItems: BASKET_SITEITEMS,
            projectItems: BASKET_PROJECTITEMS,
            trayItems: BASKET_TRAYITEMS,
            isSideBar: false,
            resizeObserver: null,
            checkoutTypeMixed: CHECKOUT_TYPE_MIXED
        };
    },
    computed: {
        ...mapGetters({
            basketItems: "newBasketPage/getBasketItems",
            loader: "newBasketPage/getLoader",
            saveForLater: "newBasketPage/getSaveForLater",
            basketCount: "newBasketPage/getBasketCount",
            saveForLaterCount: "newBasketPage/getSaveForLaterCount",
            quantityValidation: "newBasketPage/getQuantityValidation",
            quantityValidationForSameSamples: "newBasketPage/getQuantityValidationForSameSamples",
            sampleSizeValidation: "newBasketPage/getSampleSizeValidation",
            checkoutType: "newBasketPage/getCheckoutTypeProceed",
        }),

        getGtmEventBasketItems() {
            if(this.basketItems && this.basketItems.ProjectItems && this.basketItems.SiteItems) {
                return [].concat(this.basketItems.ProjectItems, this.basketItems.SiteItems)
            } else {
                return []
            }
        },
        projectAndSiteItemsMaxCartLimitValidation() {
            return ((this.basketItems.SiteItems.length + this.basketItems.ProjectItems.length) > this.maxallowedcartitems)
        },
        trayItemsMaxCartLimitValidation() {
            return (this.basketItems.TrayItems.length > this.maxallowedcartitems)
        },
        isAccordionExpand() {
            if(this.basketItems.SiteItems.length > 0) {
                return this.siteItems
            } else if(this.basketItems.ProjectItems.length > 0) {
                return this.projectItems
            } else if(this.basketItems.TrayItems.length > 0) {
                return this.trayItems
            } else if(this.saveForLater.SiteItems.length > 0) {
                return `saveForLater-${this.siteItems}`
            } else if(this.saveForLater.ProjectItems.length > 0) {
                return `saveForLater-${this.projectItems}`
            } else {
                return ''
            }
        }
    },
    watch: {
        basketItems: function (newValue, oldValue) {
            this.isSideBar = newValue.HasSiteItems || newValue.HasTrayItems || newValue.HasProjectItems || (newValue.LatestIdeaBook && newValue.LatestIdeaBook.IdeabookCoverImage);
            if (newValue.ShowAddIdeaBookModal && !newValue.IsRedirection) {
                this.$modal.show("pc-ideabook-recommendation-modal");
            }
        if (newValue.IsRedirection && !newValue.IsQuantityExceeded) {              
                this.updateloader(true);
                let url = new URL(window.location);                
                window.location.href = url.origin + "/Checkout";
            }
        }
    },
    methods: {
        ...mapActions({
            fetchBasketItem: "newBasketPage/fetchBasketItem",
            fetchSaveForLaterItems: "newBasketPage/fetchSaveForLaterItems",
            fetchFullTypeSizeSamples: "newBasketPage/fetchFullTypeSizeSamples",
            updateCheckedCheckoutProceed: "newBasketPage/updateCheckedCheckoutProceed",
            updateMaxCartLimit: "newBasketPage/updateMaxCartLimit",
            updateloader: "newBasketPage/updateLoader",
            notificationAdd: "notifications/add",
            checkOutPost: "newBasketPage/checkOutPost",
        }),
        errorMsgForSideBar() {
            if(this.quantityValidation && !this.sampleSizeValidation ) {
                return this.$resourceString['basket.QuantityLimit'] 
            } if(this.quantityValidationForSameSamples && this.quantityValidationForSameSamples.isError && !this.quantityValidation && !this.sampleSizeValidation ) {
                return `<span>${this.quantityValidationForSameSamples.SellingStyleNumber}, ${this.quantityValidationForSameSamples.SellingColorNumber}</span>, ${this.$resourceString['basket.QuantityLimit']}`
            } else if(this.sampleSizeValidation) {
                return this.$resourceString["basket.ValidationError"]
            } else if(this.projectAndSiteItemsMaxCartLimitValidation && this.basketItems.SiteItems.length > 0 &&  this.basketItems.ProjectItems.length > 0) { 
                return this.$resourceString["myBasket.MaxAllowedCartitems.ProjectAndSiteItems"]
            } else if(this.basketItems.SiteItems.length > 0 || this.basketItems.ProjectItems.length > 0) {
                return this.$resourceString["myBasket.MaxAllowedCartitems.DefaultItems"]
            } if(this.trayItemsMaxCartLimitValidation) {
                return this.$resourceString["myBasket.MaxAllowedCartitems.TrayItems"]
            } else {
                return ''
            }
        },
        isErrorForSideBar() {
            return (this.quantityValidation || (this.quantityValidationForSameSamples && this.quantityValidationForSameSamples.isError) || this.sampleSizeValidation || this.projectAndSiteItemsMaxCartLimitValidation  || this.trayItemsMaxCartLimitValidation)
        },
        async continueToCheckOutIdeabook(addIdeaBook, declineAddIdeaBook) {
            const self = this;
            let payload = {
                declineAddIdeaBook: declineAddIdeaBook,
                addIdeaBook: addIdeaBook,
                checkoutType: this.checkOutType
            };
           const status = await self.checkOutPost(payload);
           if(status) {
               self.$modal.hide("pc-ideabook-recommendation-modal");
            }
        },

        async continueToCheckOut(type) {
            const self = this;
            const payload = {
                checkoutType: type
            }      
            self.$gtm.viewCartEvent(this.getGtmEventBasketItems, this.GTMEventNameBegin);
            await self.checkOutPost(payload);
        },

        scrollMethod() {
            let currentScroll = (document.documentElement.scrollTop || document.body.scrollTop);
            const element = document.querySelector(".sidebar-mobile-device");
            if(element) {
                const divTop = element.getBoundingClientRect().top + window.scrollY;
                const windowHeight = window.innerHeight;
                const result = divTop - windowHeight;
                if(currentScroll >= result) {
                    element.classList.remove("__sticky")
                } else {
                    element.classList.add("__sticky")               
                }
            }           
        }
    },
    async mounted() {
        await this.fetchBasketItem();
        await this.fetchSaveForLaterItems();
        await this.fetchFullTypeSizeSamples();
        let maxCartLimit = {
             maxallowedcartitems: this.maxallowedcartitems,
             maxallowedsamplesincartitem: this.maxallowedsamplesincartitem,
             maxfullsizeitems: this.maxfullsizeitems
        };
        await this.updateMaxCartLimit(maxCartLimit); 
        
        // sidebaar sticky for bottom
        window.addEventListener("scroll", this.scrollMethod);
        this.resizeObserver = new ResizeObserver(() => this.scrollMethod())
        this.resizeObserver.observe(document.body);
    },
    destroyed(){
        window.removeEventListener("scroll", this.scrollMethod);
        this.resizeObserver.disconnect();
    },
};
</script>
